import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'working-days',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class WorkingDays extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({ default: { month: 30, week: 7 } })
    private value: any;

    @Prop()
    private isReadOnly: any;

    // ---------------------------------------------------------------------
    // Methods


    private updateScore(value: any) {
        value.month = (typeof (value.month) === 'string') ? parseInt(value.month, 10) : value.month;
        value.week = (typeof (value.week) === 'string') ? parseInt(value.week, 10) : value.week;
        this.$emit('input', value);
    }

    private showMore() {
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }
}
